import {html, css, LitElement} from 'lit';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import {createComponent} from "@lit/react";
import React from "react";

export class HtmlPreviewerWC extends LitElement {

    static properties = {
        html: '',
    };

    static styles = css`
        img {
            -webkit-user-drag: none;
            -khtml-user-drag: none;
            -moz-user-drag: none;
            -o-user-drag: none;
            user-drag: none;
        }
  `;

    constructor() {
        super();
        this.html = '';
        this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        super.disconnectedCallback();
    }

    setZoom(zoom, el) {
        const transformOrigin = [0, 0];
        const p = ["webkit", "moz", "ms", "o"];
        const s = `scale(${zoom})`;
        const oString = `${transformOrigin[0] * 100}% ${transformOrigin[1] * 100}%`;

        // Stel transform en transform-origin in voor de wrapper
        p.forEach((prefix) => {
            el.style[`${prefix}Transform`] = s;
            el.style[`${prefix}TransformOrigin`] = oString;
        });
        el.style.transform = s;
        el.style.transformOrigin = oString;

        // Bereken en stel de hoogte van het `html-previewer`-element in
        const scaledHeight = el.scrollHeight * zoom;
        this.style.height = `${scaledHeight + window.innerHeight /4}px`;
        this.style.display = 'block';
    }

    handleResize(a){
        const zoomScale = this.parentElement.offsetWidth / (this.shadowRoot.getElementById('wrapper').offsetWidth);
        this.setZoom(zoomScale,this.shadowRoot.getElementById('wrapper'))
    }

    updated(changedProperties) {
        this.handleResize();
        if( !this.html){
            return;
        }
        const fontFaceRegex = /@font-face\s*\{[^}]*\}/g;
        const matches = this.html.match(fontFaceRegex);

        if (matches) {
            // Combineer alle @font-face regels in één string
            const combinedFontFaces = matches.join('\n');

            // Zoek naar een bestaande <style> tag in de <head>
            let styleTag = document.head.querySelector('style.font-face-styles');

            if (styleTag) {
                // Als de <style> tag al bestaat, vervang deze
                styleTag.textContent = combinedFontFaces;
            } else {
                // Als de <style> tag nog niet bestaat, maak deze aan en voeg deze toe aan de <head>
                styleTag = document.createElement('style');
                styleTag.className = 'font-face-styles'; // Voeg een class toe om later gemakkelijk te kunnen vinden
                styleTag.textContent = combinedFontFaces;
                document.head.appendChild(styleTag);
            }
        }

    }

    firstUpdated() {
        this.handleResize();
    }

    render() {
        return html`
            <div id="wrapper" style="width: fit-content">
                ${unsafeHTML(this.html)}
            </div>
        `;
    }
}

customElements.define('html-previewer', HtmlPreviewerWC);

const HtmlPreviewer = createComponent({
    react: React,
    tagName: 'html-previewer',
    elementClass: HtmlPreviewerWC,
});

export {
    HtmlPreviewer
}
